/**
 * Internal types for the scope panel. Server response types live in
 * ../api.ts; these are the projection types used by the tree renderer.
 */
import { ScopeEnvelope, ScopeOptionsInstance } from '../api';

/**
 * One scenario as the tree renderer consumes it. Identity is
 * (model_instance_id, scenario_id). Names + tag are display-only.
 */
export interface ScopeTreeScenario {
  scenario_id: number;
  scenario_name: string;
  tag: string | null;
  // Inherited from the parent instance, denormalized for selection
  // semantics (a selected scenario carries enough identity to write
  // a ScopeEntry without re-walking the tree).
  forecast_model_id: number;
  forecast_model_name: string;
  model_instance_id: number;
  model_instance_name: string;
}

/**
 * One instance node in the tree.
 */
export interface ScopeTreeInstance {
  forecast_model_id: number;
  forecast_model_name: string;
  model_instance_id: number;
  model_instance_name: string;
  scenarios: ScopeTreeScenario[];
}

/**
 * One model node in the tree.
 */
export interface ScopeTreeModel {
  forecast_model_id: number;
  forecast_model_name: string;
  instances: ScopeTreeInstance[];
}

export interface ScopeOptionsState {
  options: ScopeOptionsInstance[]; // raw from server, full client tree
  currentScope: ScopeEnvelope; // never null at component-state level; null collapses to empty entries
}

export type ScenarioKey = string; // `${model_instance_id}:${scenario_id}`

export function scenarioKey(
  modelInstanceId: number,
  scenarioId: number
): ScenarioKey {
  return `${modelInstanceId}:${scenarioId}`;
}
